const USdata = {
  "editor.alreadyEntered": "already entered {count}/{maxLength}",
  "editor.placeholder": "say...",
  "editor.maxLength": "Input number must < {maxLength}",
  "editor.SubmitBtn": "Submit",
  "editor.uploadTip": "Upload Pictures",
  "editor.uploadCount": "(You can also upload {count} images)",
  "editor.uploadBtn": "upload",

  "comment.tourist": "tourist",
  "comment.totalComment":
    "total {total, plural, =1 {one comment} other {# comments}}",
  "comment.reply": "reply",
  "comment.moreComment": "More",

  "reply.totalReply": "{total, plural, =1 {one reply} other {# replies}}",
  "reply.moreReply": "More",
  "reply.collapse": "clloasp reply",

  "picture.collapse": "collapse",
  "picture.viewOriginal": "view original picture",

  "popConfirm.title": "Sure?",
  "popConfirm.ok": "Ok",
  "popConfirm.cancel": "Cancel",
  "popConfirm.delete": "Delete",

  "message.noMoreComment": "no more comment",
  "message.noMoreData": "no more data",
  "message.notNull": "comment not null",
  "message.success": "comment success",
  "message.replyNoNull": "reply not null",
  "message.replySuccess": "reply success",
  "message.cancelLickSuccess": "cancel like success",
  "message.likeSuccess": "like success"
};

export default USdata;
